/**
@ngdoc directive
@name locator

@description
Locator Widget

@usage
    <locator
        label="Cost codes"	// label for the whole field
        prefix="locator"    // (optional) fields' prefix ('locator' by default)
        ng-required="true"	// (optional) required
        ng-readonly="false" // (optional) read only field
        ng-disabled="false" // (optional) disabled field
        types="{
            14:{id:14, option:'Telephone'}, // idNum:{id:idNum, option:'optionName'}
            13:{id:13, option:'Email', type:'email'},
            16:{id:16, option:'Website'},
            15:{id:15, option:'Social Account'}
        }"                  // (optional) Type field options (default: { 14:{id:14, option:'Telephone'}, 13:{id:13, option:'Email', type:'email'}, 16:{id:16, option:'Website'}, 15:{id:15, option:'Social Account'} })
        name-column="false" // (optional) enable Name column (true by default) // for Candidate,Manager & Biz.
        init= "	            // (optional) init values (will be loaded on widget load)
        warnings="[{
            locatorTypeList: ['email'],
            displayCondition: (formModel.unsubscribedFromEmails),
            message: 'Please do not send them sales EMAILS.',
            tooltip: 'They have opted out of sales EMAILS'
        },{
            locatorTypeList: ['telephone','mobile','phone'],
            displayCondition: (formModel.unsubscribedFromCalls),
            message: 'Please do not contact for sales CALLS.',
            tooltip: 'They have opted out of sales CALLS'
        }]"                 // (optional) allow definition of warnings for targeted fields for specified conditions
    >
    </locator>
*/

(function() {
  'use strict';

var locators = function($timeout, $templateCache) {
    return {
        restrict: "EA",
        scope: {
            label:"@",
            prefix:"@",
            ngRequired: "=",
            ngReadonly: "=",
            ngDisabled: "=",
            warnings: "="
        },
        bindToController: {
            init: "&",
            nameColumn: "@",
            types: '&'
        },
        controllerAs:'ctrl',
        replace: true,
        transclude: false,
        template: $templateCache.get("formWidget/locators.html"),
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            // init values
            var _this = this;

            this.$onInit = function(){
                initialize();
            }

            $scope.addLocator = function($event){
                $event.preventDefault();

                if($scope.ngDisabled){
                    return false;
                }

                if($scope.subformNewLoc.$valid) {
                    // add locator
                    $scope.locators.push( $scope.newLocator );
                    updateWidgetState();
                    // and reset the form
                    $scope.newLocator = {};
                    $scope.newLocatorErrorMsg = false;
                } else {
                    $scope.newLocatorErrorMsg = true;
                    return false;
                }
            }

            $scope.getLocatorchecklist = function(locator){
                var myArray = $scope.locators.map($scope.getLocatorDetails);
                // adding extra values to checklist for canditate / buisness and manager
                if ($scope.$parent.formModel.mobile) {
                    if ($scope.$parent.formModel.mobile.detail || $scope.$parent.formModel.mobile.detail === ''){
                        myArray.push($scope.$parent.formModel.mobile.detail);
                    } else {
                        myArray.push($scope.$parent.formModel.mobile);
                    }
                }
                if ($scope.$parent.formModel.phone) {
                    if ($scope.$parent.formModel.phone.detail || $scope.$parent.formModel.phone.detail === ''){
                        myArray.push($scope.$parent.formModel.phone.detail);
                    } else {
                        myArray.push($scope.$parent.formModel.phone);
                    }
                }
                if ($scope.$parent.formModel.switchboard) {
                    if ($scope.$parent.formModel.switchboard.line || $scope.$parent.formModel.switchboard.line === ''){
                        myArray.push($scope.$parent.formModel.switchboard.line);
                    } else {
                        myArray.push($scope.$parent.formModel.switchboard);
                    }
                }
                if ($scope.$parent.formModel.email) {
                    myArray.push($scope.$parent.formModel.email);
                }

                if (locator) {
                    var index = myArray.indexOf(locator);
                   
                    if (index !== -1) {
                        myArray[index] = '';
                    
                    }  
                }

                myArray = myArray.map( $scope.cleanArray)
                  
            
                return myArray
            }

            $scope.cleanArray = function(element){
                let el = element || '';
                el =  '' + el;

                // ideally we would be doing something of the sort 
                // el = encodeURIComponent(el)
                // but that would need the back end to be able to take care of everything including @ which currently works 
                // for X3-18514 ($http post removes the + sign by default for security reasons it needs to be encoded as it is a special char see validationRemote.js)
                let a = el.replaceAll('+', '%2B')
                
                return a;
            }

            $scope.getLocatorDetails = function(element){
                return element.details || '';
            }

            $scope.removeLocator = function(index, event){
                event.preventDefault();

                $scope.removedLocators.push( $scope.locators.splice(index, 1)[0] );
                updateWidgetState();
                $scope.updateValidityCondition();

                $element.focus(); // a11y
            }

            function updateWidgetState(){
                $scope.widget.state.widgetTouched = true;
                $scope.widget.state.locatorsNum = $scope.locators.length;
            }

            function initialize(){
                $scope.widget = {};

                $scope.widget.isNameCol = (angular.isDefined(_this.nameColumn) && _this.nameColumn=="false") ? false : true;
                $scope.widget.colSpanNum = $scope.widget.isNameCol ? 4 : 3;

                $scope.widget.types = angular.isDefined(_this.types()) ? _this.types() : {
                    14:{id:14, option:'Telephone', type:'phone'},
                    13:{id:13, option:'Email', type:'email'},
                    16:{id:16, option:'Website'},
                    15:{id:15, option:'Social Account'},
                    5206:{id:5206, option:'Emergency Contact'},
                    5204:{id:5204, option:'Mobile', type:'mobile'},
                    5205:{id:5205, option:'Work Fax'}

                };

                $scope.prefix   = $scope.prefix || 'locator'; // default fields' prefix
                $scope.locators = _this.init() || new Array();
                angular.forEach( $scope.locators, function(val, key){
                    val.type = $scope.widget.types[val.type];
                }); // this is required for ng-option in type <select>s

                $scope.newLocator = {};
                $scope.removedLocators = new Array();

                $scope.widget.state = {
                    locatorsNum: $scope.locators.length,
                    newLocatorInvalid: false,
                    widgetTouched: false,
                    addLocatorHasFocus: false
                };

            };
        }],
        require: '^form', // parent form binding
        link: function(scope, element, attrs, formCtrl) {

            scope.form = formCtrl;

            scope.updateValidityCondition = function(){
                $timeout(function(){
                    scope.widget.state.newLocatorInvalid = (
                        (scope.subformNewLoc[scope.prefix+'.type'].$touched && (!scope.newLocator.type || !scope.widget.state.addLocatorHasFocus) ) ||
                        (scope.subformNewLoc[scope.prefix+'.details'].$touched && (!scope.newLocator.details || !scope.widget.state.addLocatorHasFocus) )
                    );
                    if(scope.widget.isNameCol){
                        scope.widget.state.newLocatorInvalid = scope.widget.state.newLocatorInvalid ||
                            (scope.subformNewLoc[scope.prefix+'.name'].$touched && (!scope.newLocator.name || !scope.widget.state.addLocatorHasFocus) );
                    }

                    if(!scope.widget.state.addLocatorHasFocus || scope.widget.state.newLocatorInvalid){
                        // once touched it's touched
                        scope.widget.state.widgetTouched = true;
                    }
                });
            }

        }
    };
}
locators.$inject = ['$timeout', '$templateCache'];
angular.module('app').directive('locators', locators);

}());
